module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container edit-user-template"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [(_vm.canEditColors) ? [_vm._v("\n        Edit industry colors:\n      ")] : _vm._e(), _vm._v(" "), (_vm.canEditLogo) ? [_vm._v("\n        Edit industry colors:\n      ")] : _vm._e(), _vm._v("\n      " + _vm._s(this.industry.details.name) + "\n    ")], 2), _vm._v(" "), _c('div', {
    staticClass: "profile-actions float-none"
  }, [_c('button', {
    staticClass: "delete-profile background-1-20 color-2-100",
    class: [{
      'not-allowed': (_vm.industry.details.companies && _vm.industry.details.companies.length) || _vm.industry.details.id === 1
    }],
    attrs: {
      "title": _vm.deleteMessage()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteIndustry()
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), (_vm.resetNeeded) ? _c('button', {
    staticClass: "reset-btn background-1-20 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resetToDefault()
      }
    }
  }, [_vm._v("\n        Reset to default\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "admin-gm-breadcrumbs",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('router-link', {
    staticClass: "dashboard",
    attrs: {
      "to": {
        name: 'edit-industry',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Basic data")]), _vm._v(" "), (_vm.landing) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-landing',
        params: {
          id: _vm.landing
        }
      }
    }
  }, [_vm._v("Landing")]) : _vm._e(), _vm._v(" "), (!_vm.landing) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createLanding()
      }
    }
  }, [_vm._v("Create landing")]) : _vm._e(), _vm._v(" "), (_vm.registrationLanding) ? _c('router-link', {
    staticClass: "landing",
    attrs: {
      "to": {
        name: 'company-registration-landing',
        params: {
          industry: _vm.registrationLanding,
          company: 'default'
        }
      }
    }
  }, [_vm._v("Registration landing")]) : _vm._e(), _vm._v(" "), (!_vm.registrationLanding) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createRegistrationLanding()
      }
    }
  }, [_vm._v("Create registration landing")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "companies",
    attrs: {
      "to": {
        name: 'edit-industry-emails',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom emails")]), _vm._v(" "), _c('router-link', {
    staticClass: "companies active",
    attrs: {
      "to": {
        name: 'edit-industry-styling',
        params: {
          id: _vm.industryId
        }
      }
    }
  }, [_vm._v("Custom email and website styling")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "industryColors",
    staticClass: "content-section content-section__bordered border-1-20 no-margin-top"
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditColors === false) ? [_vm._v("Industry colors")] : [_vm._v("Edit industry colors")]], 2), _vm._v(" "), (_vm.canEditColors === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditColors()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideDatepicker),
      expression: "hideDatepicker"
    }],
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "main-color-one"
    }
  }, [_vm._v("Main color one")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.details.mainColorOne),
      expression: "industry.details.mainColorOne"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Main color one')
    }],
    attrs: {
      "type": "color",
      "disabled": _vm.canEditColors === false,
      "data-lpignore": "true",
      "id": "main-color-one",
      "name": "Main color one"
    },
    domProps: {
      "value": (_vm.industry.details.mainColorOne)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry.details, "mainColorOne", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Main color one')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                " + _vm._s(this.errors.first('Main color one')) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideDatepicker),
      expression: "hideDatepicker"
    }],
    staticClass: "form-group form-group-half"
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('label', {
    staticClass: "form-label color-2-63",
    attrs: {
      "for": "main-color-two"
    }
  }, [_vm._v("Main color two")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.industry.details.mainColorTwo),
      expression: "industry.details.mainColorTwo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control__input background-1-10-disabled  border-1-10-disabled",
    class: [{
      'has-error': _vm.errors.has('Main color two')
    }],
    attrs: {
      "type": "color",
      "disabled": _vm.canEditColors === false,
      "data-lpignore": "true",
      "id": "main-color-two",
      "name": "Main color two"
    },
    domProps: {
      "value": (_vm.industry.details.mainColorTwo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.industry.details, "mainColorTwo", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Main color two')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v("\n                " + _vm._s(this.errors.first('Main color two')) + "\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditColors) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditColors()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryColors()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "industryLogo",
    staticClass: "content-section content-section__bordered border-1-20",
    class: [{
      'content-section__dark': _vm.canEditLogo === false
    }]
  }, [_c('article', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditLogo === false) ? [_vm._v("Industry logo")] : [_vm._v("Edit industry logo")]], 2), _vm._v(" "), (_vm.canEditLogo === false) ? _c('button', {
    staticClass: "edit-details border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditLogo()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.canEditLogo === true) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "sponsor-list"
  }, [_c('div', {
    staticClass: "sponsor-item"
  }, [_c('div', {
    staticClass: "sponsor-item-logo sponsor-item-logo-industry",
    attrs: {
      "id": 'uploadLogo'
    }
  }, [(_vm.industry.details.customLogo !== null) ? _c('div', {
    staticClass: "sponsor-item-logo__image sponsor-item-logo__image-industry",
    style: ({
      backgroundImage: _vm.getImage(_vm.industry.details.customLogo)
    })
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.industry.details.customLogo === null),
      expression: "industry.details.customLogo === null"
    }],
    staticClass: "form-label color-2-63 form-label__logo-upload",
    class: [{
      'disabled': _vm.canEditLogo === false
    }],
    attrs: {
      "for": 'uploadInput'
    }
  }, [_vm._v("\n                    +Upload logo\n                    "), (_vm.industry.details.customLogo === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate.reject",
      value: (_vm.veeValidateFileUploadRules),
      expression: "veeValidateFileUploadRules",
      modifiers: {
        "reject": true
      }
    }],
    staticClass: "form-control form-control--file",
    attrs: {
      "type": "file",
      "disabled": _vm.canEditLogo === false,
      "id": 'uploadInput',
      "name": "Thumbnail",
      "data-vv-as": "\"Thumbnail\"",
      "value.sync": "industry.details.customLogo",
      "placeholder": "+Upload logo"
    },
    on: {
      "change": function($event) {
        return _vm.onThumbnailFileChange($event)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.industry.details.customLogo !== null) ? _c('div', {
    staticClass: "sponsor-item-logo__remove",
    on: {
      "click": function($event) {
        return _vm.removeLogo()
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('span', {
    staticClass: "sponsor-item-logo__info"
  }, [_vm._v("\n              Max size: 275px / 75px. Recommended: 275px / 35px.\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.canEditLogo === false) ? _c('div', {
    staticClass: "sponsors-list__edit"
  }, [(_vm.industry.details.customLogo !== '') ? _c('div', {
    staticClass: "sponsor-item"
  }, [_c('div', {
    staticClass: "sponsor-item-logo",
    attrs: {
      "id": 'uploadLogo'
    }
  }, [_c('img', {
    staticClass: "sponsor-item-logo__image",
    attrs: {
      "src": _vm.getImageFullPath(_vm.industry.details.customLogo)
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditLogo) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditLogo()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateIndustryLogo()
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before"
  }, [_c('div', {
    staticClass: "anchor-item color-1-20 colors",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryColors'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryColors')
      }
    }
  }, [_vm._v("Industry colors")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 sponsors",
    class: [{
      'active  color-1-100': _vm.activeSection === 'industryLogo'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('industryLogo')
      }
    }
  }, [_vm._v("Industry logo")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704280e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/EditIndustryStyling.vue
// module id = 1021
// module chunks = 0